import { createAction } from 'redux-actions'
import { RootState } from '../reducers'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { url, post } from '../../assets/javascripts/http'
import { message, Modal } from 'antd'
import { getCurrentMessages } from '../../assets/javascripts/intl'
import { isHasBasicInfo, formatDate } from '../../assets/javascripts/generic'
import { actionLogoutSuccess } from './user'
import { ExaminationService, PostureService, ExaminationReportRelationshipDtoResult } from "../adapters"

let examinationService = new ExaminationService(url, post)
let postureService = new PostureService(url, post)

// 获取用户列表

export function actionGetCustomerList () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return ;
        }
        try {
            message.loading(getCurrentMessages().loading)
            let res = await examinationService.getMyExamineeList({
                clientList:['posture-expert-dashboard','posture_detection_app',]
            });
            let examineeResults = res.ExamineeResults;
            let examinees: number[] = [];
            examineeResults.map((item) => {
                if(item.examineeId) {
                    examinees.push(item.examineeId)
                }
            })
            let data_report = {
                examinees: examinees
            }
            let res_report = await examinationService.getExamineesExaminationReportList(data_report);
            let results = res_report.examinationReportRelationshipMapResults;
            examineeResults.map((item) => {
                if(item.examineeId && results[item.examineeId]) {
                    let report = results[item.examineeId].examinationReportRelationshipResults;
                    let obj = {
                        report,
                        total: report.length
                    }
                    Object.assign(item, obj)
                }
                else {
                    let obj = {
                        report: [],
                        total: 0
                    }
                    Object.assign(item, obj)
                }
                return item;
            })
            dispatch(actionGetCustomerListSuccess({
                data: examineeResults
            }))
            message.destroy();
        } catch (error: any) {
            message.destroy();
            let response = error.response;
            if(response && response.status === 500) {
                let headers = error.response.headers;
                let str = headers['senno-exception-message'];
                if(str.toLowerCase().search('account id not found') != -1) {
                    dispatch(actionLogoutSuccess({
                        loginStatus: false,
                        invaildLogin: true
                    }))
                    console.log('重新登录...')
                }
                else {
                   message.error('系统错误', 5)
                   console.log('系统错误')
                }
            }
        }
    }
}

export const ACTION_GETCUSTOMERLIST_SUCCESS = 'USER.ACTION_GETCUSTOMERLIST_SUCCESS';

export interface ActionGetCustomerListPayload {
    data: any
}

const actionGetCustomerListSuccess = createAction(
    ACTION_GETCUSTOMERLIST_SUCCESS,
    (payload: ActionGetCustomerListPayload) => {
        return payload;
    }
)


export function actionUpdateCustomer (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return ;
        }
        try {

            await examinationService.updateExaminee(data)
            dispatch(actionUpdateCustomerSuccess({
                data: {}
            }))

            dispatch(actionGetCustomerList())
            message.destroy();
        } catch (error: any) {
            message.destroy();
            console.log(error)
        }
    }
}

export const ACTION_UPDATECUSTOMER_SUCCESS = 'USER.ACTION_UPDATECUSTOMER_SUCCESS';

export interface ActionUpdateCustomerPayload {
    data: any
}

const actionUpdateCustomerSuccess = createAction(
    ACTION_UPDATECUSTOMER_SUCCESS,
    (payload: ActionUpdateCustomerPayload) => {
        return payload;
    }
)


export function actionDeleteCustomer (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return ;
        }
        try {

            await examinationService.deleteExaminationRelationship(data)
            dispatch(actionDeleteCustomerSuccess({
                data: {}
            }))

            dispatch(actionGetCustomerList())
            message.destroy();
        } catch (error: any) {
            message.destroy();
            console.log(error)
        }
    }
}

export const ACTION_DELETECUSTOMER_SUCCESS = 'USER.ACTION_DELETECUSTOMER_SUCCESS';

export interface ActionDeleteCustomerPayload {
    data: any
}

const actionDeleteCustomerSuccess = createAction(
    ACTION_DELETECUSTOMER_SUCCESS,
    (payload: ActionDeleteCustomerPayload) => {
        return payload;
    }
)

export type TrendData = {
    lateralhead: number[],
    unevenshoulder: number[],
    unevenhip: number[],
    legLeft: number[],
    legRight: number[],
    forwardhead: number[],
    roundedshoulder: number[],
    kneehyperextension: number[],
}

export function actionGetCustomerDetail (id) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        // if(!isHasBasicInfo()) {
        //     dispatch(actionLogoutSuccess({
        //         loginStatus: false
        //     }))
        //     return ;
        // }
        try {

            message.loading(getCurrentMessages().loading)
            let data_ex = {
                examineeId: id
            }
            let res_ex = await examinationService.getExamineeById(data_ex)
            let data_report = {
                examinees: id
            }
            let res_report = await examinationService.getExamineesExaminationReportList(data_report);
            let results = res_report.examinationReportRelationshipMapResults;
            let uuids: string[] = [];
            let resultList: ExaminationReportRelationshipDtoResult[]  = [];
            if(results[id]) {
                resultList = results[id].examinationReportRelationshipResults.map((item) => {
                    uuids.push(item.examinationReportResults.examineeReportDetailId)
                    return item;
                })
            }
            uuids = Array.from(new Set(uuids))
            let list: any = [];
            if(uuids.length) {
                let data_posture: any = {
                    uuid: uuids,
                    language: 'zh',
                }
                let res_posture = await postureService.getPostureReportList(data_posture);
                list = res_posture.postureReportList;
            }

            // let slist: any = [];
            list = list.map((item: any) => {

                if(item.status !== 'COMPLETED' || item.resultPosture !== 'OK')  return item;
                let res = results[id].examinationReportRelationshipResults.filter((r) => {
                    return r.examinationReportResults?.examineeReportDetailId === item.uuid
                })[0] || {};
                let risks = [...item.body.front.risks, ...item.body.side.risks];
                let highRisks = risks.filter((r) => {
                    return r.level === 'severe'
                }) || [];
                let mediumRisks = risks.filter((r) => {
                    return r.level === 'mild'
                }) || [];
                let lowRisks = risks.filter((r) => {
                    return r.level === 'normal'
                }) || [];

                let obj = Object.assign(item);
                obj.highRiskTotal = highRisks.length;
                obj.mediumRiskTotal = mediumRisks.length;
                obj.lowRiskTotal = lowRisks.length;
                obj.time = res.examinationReportResults?.creationTimestamp;
                obj.examinationReportId = res.examinationReportResults?.examinationReportId;
                // slist.push(obj)
                return obj;
            })

            let timesList: string[] = [];

            let trend_data: TrendData = {
                lateralhead: [],
                unevenshoulder: [],
                unevenhip: [],
                legLeft: [],
                legRight: [],
                forwardhead: [],
                roundedshoulder: [],
                kneehyperextension: [],
            };
            let trend_risk = {
                '头部前倾': [],
                '头部侧倾': [],
                '圆肩': [],
                '高低肩': [],
                '骨盆侧倾': [],
                '脊柱异位': [],
                '膝过伸': [],
                'X型腿': [],
                'O型腿': [],
            }
            list = list.map((item, index) => {

                let obj = resultList.filter((r) => {
                    return r.examinationReportResults?.examineeReportDetailId === item.uuid
                })[0] || {};
                let time = formatDate(obj.examinationReportResults?.creationTimestamp)
                item.creationTimestamp = time;

                if(!item.body) {
                    return item;
                }

                let risks = [...item.body.front.risks, ...item.body.side.risks];
                for(let i in trend_data) {

                    let risk = risks.filter((r) => {
                        return r.key === i
                    })[0] || {};

                    if(i=== 'legLeft') {
                        risk = risks.filter((r) => {
                            return r.detail === '左腿'
                        })[0] || {};
                    }
                    else if(i=== 'legRight') {
                        risk = risks.filter((r) => {
                            return r.detail === '右腿'
                        })[0] || {};
                    }
                    if(risk.value) {
                        trend_data[i].push(+risk.value.toFixed(2))
                    }
                    else {
                        trend_data[i].push(0)
                    }
                }
                for(let i in trend_risk) {
                    let risk = risks.filter((r) => {
                        return r.name === i
                    })[0] || {};
                    if(risk.value) {
                        trend_risk[i].push(+risk.value.toFixed(0))
                    }
                    else {
                        trend_risk[i].push(0)
                    }
                }

                timesList.push(time)
                return item;
            })
           console.log(trend_data)
            let obj = {
                ...res_ex.examineeResult,
                list: list,
                chartData: {
                    timesList,
                    trend_data,
                    trend_risk
                }
            }
            dispatch(actionGetCustomerDetailSuccess({
                data: obj
            }))
            message.destroy();
        } catch (error: any) {
            message.destroy();
            console.log(error)
        }
    }
}

export const ACTION_GETCUSTOMERDETAIL_SUCCESS = 'USER.ACTION_GETCUSTOMERDETAIL_SUCCESS';

export interface ActionGetCustomerDetailPayload {
    data: any
}

const actionGetCustomerDetailSuccess = createAction(
    ACTION_GETCUSTOMERDETAIL_SUCCESS,
    (payload: ActionGetCustomerDetailPayload) => {
        return payload;
    }
)

export function actionGetReportContrast (uuid1: string, uuid2: string, lang: string) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        // if(!isHasBasicInfo()) {
        //     dispatch(actionLogoutSuccess({
        //         loginStatus: false
        //     }))
        //     return ;
        // }
        message.loading(getCurrentMessages().loading)

        try {
            let data_posture1 = {
                uuid: uuid1,
                language: lang,
            }
            let res_posture1 = await postureService.getPostureReport(data_posture1);

            let data_posture2 = {
                uuid: uuid2,
                language: lang,
            }
            let res_posture2 = await postureService.getPostureReport(data_posture2);

            let degs1 = {
                front: {
                    lateralhead: 0,
                    unevenshoulder: 0,
                    unevenhip: 0,
                    legLeft: 0,
                    legRight: 0,
                    scoliosis: 0,
                },
                side: {
                    forwardhead: 0,
                    roundedshoulder: 0,
                    kneehyperextension: 0
                }
            }
            let degs2 = {
                front: {
                    lateralhead: 0,
                    unevenshoulder: 0,
                    unevenhip: 0,
                    legLeft: 0,
                    legRight: 0,
                    scoliosis: 0,
                },
                side: {
                    forwardhead: 0,
                    roundedshoulder: 0,
                    kneehyperextension: 0
                }
            };
            let risks1 = [...res_posture1.body.front.risks, ...res_posture1.body.side.risks];
            risks1.map((item) => {
                if(item.key === 'lateralhead') degs1.front.lateralhead = +item.raw.toFixed(2);
                if(item.key === 'unevenshoulder') degs1.front.unevenshoulder = +item.raw.toFixed(2);
                if(item.key === 'unevenhip') degs1.front.unevenhip = +item.raw.toFixed(2)
                if(item.detail === '左腿') degs1.front.legLeft = +item.raw.toFixed(2);
                if(item.detail === '右腿') degs1.front.legRight = +item.raw.toFixed(2)
                if(item.key === 'scoliosis') degs1.front.scoliosis = +item.raw.toFixed(2)

                if(item.key === 'forwardhead') degs1.side.forwardhead = +item.raw.toFixed(2);
                if(item.key === 'roundedshoulder') degs1.side.roundedshoulder = +item.raw.toFixed(2);
                if(item.key === 'kneehyperextension') degs1.side.kneehyperextension = +item.raw.toFixed(2);
            });

            let risks2 = [...res_posture2.body.front.risks, ...res_posture2.body.side.risks];
            risks2.map((item) => {
                if(item.key === 'lateralhead') degs2.front.lateralhead = +item.raw.toFixed(2);
                if(item.key === 'unevenshoulder') degs2.front.unevenshoulder = +item.raw.toFixed(2);
                if(item.key === 'unevenhip') degs2.front.unevenhip = +item.raw.toFixed(2)
                if(item.detail === '左腿') degs2.front.legLeft = +item.raw.toFixed(2);
                if(item.detail === '右腿') degs2.front.legRight = +item.raw.toFixed(2)
                if(item.key === 'scoliosis') degs2.front.scoliosis = +item.raw.toFixed(2)

                if(item.key === 'forwardhead') degs2.side.forwardhead = +item.raw.toFixed(2);
                if(item.key === 'roundedshoulder') degs2.side.roundedshoulder = +item.raw.toFixed(2);
                if(item.key === 'kneehyperextension') degs2.side.kneehyperextension = +item.raw.toFixed(2)
            });

            risks1 = risks1.sort((a, b) => a.id - b.id);
            risks2 = risks2.sort((a, b) => a.id - b.id)

            let riskNames = ['脊柱异位', '头部侧倾', '头部前倾', '高低肩', '圆肩', '骨盆侧倾', '膝过伸', 'X型腿', 'O型腿'];
            let list: Object[] = [];
            list = riskNames.map((item, index) => {

                let riska = risks1.filter((r1) => {
                    return r1.name === item
                })[0] || {};
                if(riska.value) {
                    riska.value = +riska.value.toFixed(0)
                }
                else {
                    riska.value = 0;
                }
                let riskb = risks2.filter((r2) => {
                    return r2.name === item
                })[0] || {};
                if(riskb.value) {
                    riskb.value = +riskb.value.toFixed(0)
                }
                else {
                    riskb.value = 0;
                }
                return {
                    id: index,
                    name: item,
                    risk1: riska,
                    risk2: riskb
                }
            })

            dispatch(actionGetReportContrastSuccess({
                data: {
                    report1: {
                        ...res_posture1,
                        degs: degs1,
                        risks: risks1
                    },
                    report2: {
                        ...res_posture2,
                        degs: degs2,
                        risks: risks2
                    },
                    riskList: list
                }
            }))
        } catch (error: any) {
            console.log(error)
        }
        message.destroy();

    }
}

export const ACTION_GETREPORTCONTRAST_SUCCESS = 'USER.ACTION_GETREPORTCONTRAST_SUCCESS';

export interface ActionGetReportContrastPayload {
    data: any
}

const actionGetReportContrastSuccess = createAction(
    ACTION_GETREPORTCONTRAST_SUCCESS,
    (payload: ActionGetReportContrastPayload) => {
        return payload;
    }
)

export function actionGetStatistics () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return ;
        }
        try {

            await dispatch(actionGetCustomerList())

            message.loading(getCurrentMessages().loading)
            let customerList = getState().customer.customerList || [];
            let detailIds: string[] = [];
            customerList.map((item) => {
                item.report.map((r) => {
                    detailIds.push(r.examinationReportResults.examineeReportDetailId)
                })
            })
            detailIds = Array.from(new Set(detailIds))
            if(!detailIds.length) {
                message.destroy();
                return;
            }
            let data_report: any = {
                uuid: detailIds,
                language: 'zh',
            }
            let res_report = await postureService.getPostureReportList(data_report)
            let postureReportList = res_report.postureReportList || [];
            customerList = customerList.map((item) => {
                item.report.map((r) => {
                    let uuid = r.examinationReportResults.examineeReportDetailId;
                    if(uuid) {
                        let obj = postureReportList.filter((p) => {
                            return p.uuid === uuid
                        })[0] || {};
                        let risks
                        if(obj.uuid && obj.status === 'COMPLETED' && obj.resultPosture === 'OK') {
                            risks = [...obj.body.front.risks, ...obj.body.side.risks];
                        }
                        else {
                            risks = [];
                        }
                        r.postureReport = obj;
                        r.risks = risks.filter((s) => {
                            return s && s.level === 'severe'
                        });
                        return r;
                    }
                })
                return item;
            })
            console.log(customerList)
            let risks = ['头部侧倾', '头部前倾', '圆肩', '高低肩', '脊柱异位', '骨盆侧倾', 'X型腿', 'O型腿', '膝过伸'];
            let riskList = risks.map((item, index) => {
                let itemArr = customerList.filter((rep) => {
                    if(!rep.report || !rep.report.length) return false;
                    let flag = false;
                    rep.report.map((re) => {
                        let riskArr = re.risks.filter((r) => {
                            return r.name === item
                        });
                        if(riskArr.length > 0) {
                            flag = true;
                        }
                    })
                   return flag;
                })
                return {
                    riskName: item,
                    index: index,
                    item: itemArr,
                    total: itemArr.length
                }
            })

            let riskss = ['骨盆侧倾', '脊柱异位', '高低肩', '圆肩', '膝过伸', 'X型腿', 'O型腿', '头部侧倾', '头部前倾'];
            let echartList = riskss.map((item) => {
                let arr = riskList.filter((s) => {
                    return s.riskName === item
                })[0] || {};
                return arr.total
            })

            dispatch(actionGetStatisticsSuccess({
                data: {
                    riskList,
                    echartList
                }
            }))
            message.destroy();
        } catch (error: any) {
            message.destroy();
            console.log(error)
        }
    }
}

export const ACTION_GETSTATISTICS_SUCCESS = 'USER.ACTION_GETSTATISTICS_SUCCESS';

export interface ActionGetStatisticsPayload {
    data: any
}

const actionGetStatisticsSuccess = createAction(
    ACTION_GETSTATISTICS_SUCCESS,
    (payload: ActionGetStatisticsPayload) => {
        return payload;
    }
)